import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DiscoverKyotoCta() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="14082" id="ready-to-schedule" ref={sectionRef} className="relative w-full overflow-hidden bg-background text-foreground py-12 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 items-center md:grid-cols-2">
          {}
          <div className={`relative h-[50vh] w-full overflow-hidden md:h-[80vh] transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="absolute inset-0 bg-secondary/10 z-10" /> {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/inspector_portrait.png" alt="Professional inspector in branded gear" className="h-full w-full object-cover object-center transition-transform duration-[2000ms] ease-out hover:scale-105" />
          </div>

          {}
          <div className={`relative z-20 mx-auto -mt-12 w-[90%] bg-secondary p-8 shadow-2xl md:-ml-24 md:mt-0 md:w-full md:p-16 lg:p-20 transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10 md:translate-x-20"}`}>
            <div className="flex flex-col gap-6 border-l-4 border-primary pl-6 md:pl-10">
              <h2 className="font-sans text-4xl font-bold uppercase leading-tight text-secondary-foreground md:text-5xl lg:text-7xl tracking-tighter">
                Schedule Your South Florida Home Inspection
              </h2>
              
              <p className="font-sans text-lg leading-relaxed text-secondary-foreground/90 md:text-xl tracking-tight">
                Trusted Inspections provides professional home inspections, wind mitigation inspections, 4-point inspections, condo inspections, mold testing, and pre-listing inspections across South Florida.
              </p>

              <div className="flex flex-col gap-2">
                <Link to="tel:786-382-6895" className="font-mono text-3xl font-bold text-primary hover:underline md:text-4xl">
                  786-382-6895
                </Link>
                <Link to="mailto:info@trusted-fl.com" className="font-mono text-xl text-secondary-foreground hover:underline">
                  info@trusted-fl.com
                </Link>
              </div>

              <p className="font-sans text-base text-secondary-foreground/80 italic">
                Please include your property address, inspection type, and preferred date when reaching out.
              </p>

              <div className="pt-4">
                <Link to="#" className="inline-block">
                  <Button size="lg" className="h-16 rounded-none bg-primary px-10 text-xl font-bold uppercase text-primary-foreground shadow-[inset_0_2px_10px_rgba(255,255,255,0.4)] transition-all hover:bg-primary/90 hover:pl-12">
                    Schedule Now
                    <ArrowRight className="ml-2 h-6 w-6" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}